import React from 'react'
import t from 'prop-types'
import cx from 'classnames'

const StatDefault = ({ isOnDarkBg, label, pct }) => {
  return (
    <div
      className={cx('text-center md:text-left', {
        'text-gray-700': !isOnDarkBg,
        'text-white w-1/2 mx-auto': isOnDarkBg,
      })}
    >
      <div
        className={cx(
          `border-b-2 pb-3 mb-3 inline-block md:block text-4xl md:text-5xl lg:text-6xl font-serif text-center leading-none font-bold`,
          {
            'border-blue-200': !isOnDarkBg,
            'border-blue-100': isOnDarkBg,
          }
        )}
      >
        {pct}
      </div>
      <div className="text-lg md:text-base leading-tight tracking-wider uppercase font-semibold text-center">
        {label}
      </div>
    </div>
  )
}

StatDefault.propTypes = {
  isOnDarkBg: t.bool,
  label: t.string,
  pct: t.string,
}

StatDefault.defaultProps = {}

export default StatDefault
